import Vue from "vue"
import Axios from "axios"
import store from '@/store'
import router from "@/router"
window.axiosCancel = false;
const request = {
	/**
	 * axiosRequest 封装
	 * @param api_url         [string]    ：接口地址
	 * @param parms        [object]    ：接口参数（JSON格式），此参数不传递时默认为空（{}）
	 * @param showLoading     [bool]      ：false true 是否开启load加载状态  默认开启 true
	 * return null
	 */
	post(api_url,showLoading,parms) {
		if (showLoading) {
			store.commit('app/SHOWLOADING');
		}
		let session = window.sessionStorage;
		let config = {headers: {'Content-Type': 'application/json'}};
		Axios.defaults.timeout = 10*60 * 1000;
		//在请求头加入token
		Axios.defaults.headers.common['token'] = session.getItem('token') ? session.getItem('token') : '';
		Axios.defaults.headers.common['groupId'] = session.getItem('groupId') ? session.getItem('groupId') : '';
		return Axios.post(
			Vue.prototype.$api[api_url].url,
			parms,
			config
		).then(res => {
			if (showLoading) {
				store.commit('app/HIDELOADING');
			}
			// 拦截多次token失效提示弹出框
			if(window.axiosCancel) {
				return
			}
			if(res.data.code == 4) {
				request.backLogin();
				Vue.prototype.$message({
					message: res.data.msg,
					type: 'error'
				});
				window.axiosCancel = true;
				return false
			}
			else if(res.data.code == '0'){
				return res.data
			}else{
				Vue.prototype.$message({
					message: res.data.msg,
					type: 'error'
				})
				return false
			}
		})
		.catch(err=> {
			console.log(err);
			if (showLoading) {
				store.commit('app/HIDELOADING');
			}
		})
	},
	/**
	 * axiosRequest 封装
	 * @param api_url         [string]    ：接口地址
	 * @param parms        [object]    ：接口参数（JSON格式），此参数不传递时默认为空（{}）
	 * @param showLoading     [bool]      ：false true 是否开启load加载状态  默认开启 true
	 * return null
	 */
	 formData(api_url,showLoading,parms) {
		if (showLoading) {
			store.commit('app/SHOWLOADING');
		}
		let session = window.sessionStorage;
		let config = {headers: {'Content-Type': 'multipart/form-data'}};
		Axios.defaults.timeout = 10*60 * 1000;
		//在请求头加入token
		Axios.defaults.headers.common['token'] = session.getItem('token') ? session.getItem('token') : '';
		Axios.defaults.headers.common['groupId'] = session.getItem('groupId') ? session.getItem('groupId') : '';
		return Axios.post(
			Vue.prototype.$api[api_url].url,
			parms,
			config
		).then(res => {
			if (showLoading) {
				store.commit('app/HIDELOADING');
			}
			// 拦截多次token失效提示弹出框
			if(window.axiosCancel) {
				return
			}
			if(res.data.code == 4) {
				request.backLogin();
				Vue.prototype.$message({
					message: res.data.msg,
					type: 'error'
				});
				window.axiosCancel = true;
				return false
			}
			else if(res.data.code == '0'){
				return res.data
			}else{
				Vue.prototype.$message({
					message: res.data.msg,
					type: 'error'
				})
				return false
			}
		})
		.catch(err=> {
			console.log(err);
			if (showLoading) {
				store.commit('app/HIDELOADING');
			}
		})
	},
	/**
	 * 退去首页
	 */
	backLogin() {
		window.sessionStorage.clear();
		store.commit('app/HIDELOADING');
		router.push('/login');
	},
};
export default request;
